import {Component, inject, OnInit, Renderer2, signal, ViewChild} from '@angular/core';
import {APIService} from '@core/services';
import {PatientService} from '@core/services/patient.service';
import {TableComponent, TableOptions} from '@shared/components';
import {Allergy} from '@core/classes/tables/allergy';
import {HttpHeaders} from '@angular/common/http';
import {Pregnancy} from '@core/classes/tables/pregnancy';
import {NavigationEnd, Router} from '@angular/router';
import {
  SurgicalProcedureStatusActionComponent
} from '@modules/cy/patient/ps/components/surgical-procedures/actions/surgical-procedure-status-action/surgical-procedure-status-action.component';
import {
  AddSurgicalProcedureComponent
} from '@modules/cy/patient/ps/components/surgical-procedures/actions/add-surgical-procedure/add-surgical-procedure.component';
import {SurgicalProcedure} from '@core/classes/tables/surgical-procedure';
import {
  PregnancyStatusActionComponent
} from '@modules/cy/patient/ps/components/pregnancies/actions/pregnancy-status-action/pregnancy-status-action.component';
import {
  AddPregnancyComponent
} from '@modules/cy/patient/ps/components/pregnancies/actions/add-pregnancy/add-pregnancy.component';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'ncp-pregnancies',
  imports: [
    TableComponent
  ],
  templateUrl: './pregnancies.component.html',
  styleUrl: './pregnancies.component.scss',
})
export class PregnanciesComponent implements OnInit {
  @ViewChild('pregnancies') public pregnanciesEl!: TableComponent<Pregnancy>;
  protected readonly router = inject(Router);
  protected apiService = inject(APIService);
  protected patientService = inject(PatientService);
  protected renderer2 = inject(Renderer2);

  private subscription: any;
  private destroy$ = new Subject<void>();

  protected options = signal<TableOptions<Pregnancy>>(
    new TableOptions<Pregnancy>({
      id: 'pregnancies',
      type: 'Pregnancies',
      interface: Pregnancy,
      autoLoadData: false,
      ignoreColumns: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit')? [] : ['status'],
      pagination: {
        itemsPerPage: 10,
        pageNumber: 1,
        totalItems: 0,
      },
      searchComponent: null,
    })
  );

  ngOnInit(): void {
    this.getData(
      (this.router.url === '/cy/patient/ps/edit' || this.router.url === '/cy/patient/ps/create') ? -1 : 0,
      (this.router.url === '/cy/patient/ps/edit' || this.router.url === '/cy/patient/ps/create') ? -1 : 0
    );

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
      }
    });
  }

  protected getData = (mode: number = 0, status: number = 0) => {
    this.subscription = this.apiService
      .call({
        path: '/get-pregnancy',
        headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
        body: {
          mode: mode,
          status: status,
          version_id: this.patientService.patient?.version?.id || -1
        }
      })?.pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
      if(response && response.status === 1) {
        this.options.set(
          new TableOptions<Pregnancy>({
            id: 'pregnancies',
            type: 'Pregnancies',
            interface: Pregnancy,
            data: response.data,
            autoLoadData: false,
            ignoreColumns: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? [] : ['status'],
            actionsComponent: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? PregnancyStatusActionComponent : undefined,
            extraComponent: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? AddPregnancyComponent : undefined,
            pagination: {
              itemsPerPage: 10,
              pageNumber: 1,
              totalItems: response.data.length,
            },
            renderCustomRow: (td: HTMLTableCellElement, row: {}, item: string) => {
              const data = row as Pregnancy;
              if (item === 'status') {
                td.innerHTML = '';

                let iEl = this.renderer2.createElement('h2');
                if(data.status === 1) {
                  this.renderer2.addClass(iEl, 'bi');
                  this.renderer2.addClass(iEl, 'bi-eye');
                  this.renderer2.addClass(iEl, 'text-primary');
                } else {
                  this.renderer2.addClass(iEl, 'bi');
                  this.renderer2.addClass(iEl, 'bi-eye-slash');
                  this.renderer2.addClass(iEl, 'text-secondary');
                }
                this.renderer2.appendChild(td, iEl);
              }
            },
            searchComponent: null,
          })
        );
      }
    })
  }
}
